import { deleteUserOffice } from "../../api/userOfficeService";

export const useDeleteUserOffice = (successCallback) => {
    const removeUserOffice = async (id) => {
        try {
        await deleteUserOffice(id);
            if (successCallback) successCallback();
        } catch (error) {
            console.error("Failed to delete user office:", error);
            throw error;
        }
    };

    return { removeUserOffice };
};